<template>
    <div class="articles-container">
        <div class="articles-wrapper" :key="refresh">
            <div class="loader-container" v-if="pageLoader">
                <RotatingLoader :size="30" :speed="0.6" />
                <span>Loading</span>
            </div>
            <div v-else class="articles-header">
                <div :class="['articles-header-wrapper', { 'completed': !isCompleted && currentStage != 0 }]">
                    <button class="home-btn" @click="popupType = 'goHome'">
                        <img :src="require('@/assets/icons/home.svg')" alt="">
                    </button>
                    <div class="header-title-wrapper">
                        <div class="header-title">
                            <span class="doc-title">{{ prPlanTitle }}</span>
                            <RenamePopup v-if="isEditingTitle" :docName="prPlanTitle" :isEditing="isEditingTitle"
                                :id="$route.params.prCampaignId" flowType="prcampaign"
                                @update-isEdit="isEditingTitle = $event" @updated-prTitle="prPlanTitle = $event" />
                            <button class="edit-btn" @click="isEditingTitle = true">
                                <img :src="require('@/assets/icons/edit.svg')" />
                            </button>
                        </div>
                    </div>
                    <div v-if="!isCompleted && currentStage != 0" class="button-container">
                        <button v-if="false" class="share-btn" @click="showShareMenu = true">
                            <div class="completed-wrappershare">
                                <img :src="require('@/assets/icons/share.svg')"></img>
                            </div>
                        </button>
                        <button class="download-btn" :disabled="downloadLoader" @click="downloadFinalPr">
                            <div class="continue-btn">
                                <Svg :src="require('@/assets/icons/download.svg')" fill="white"></Svg>
                                <p>Download</p>
                                <v-progress-circular v-if="downloadLoader" indeterminate :size="18"
                                    :width="2"></v-progress-circular>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="currentStage == 0" class="stage-container">
                <SourceDocument :sourceList="sourceList" :flowType="'PR Strategy Playbook'" :documentId="documentId"
                    :documentType="documentType" @document-meta-selected="handleSelectedDoc" />
            </div>
            <div v-else class="completed-section" v-if="prCampaign">
                <PrPlanCompleted :prCampaign="prCampaign" :key="refresh" :isCompleted="isCompleted"/>
            </div>


            <div v-if="currentStage == 0" class="articles-footer">
                <div class="footer-left">
                    <button class="delete-btn" @click="popupType = 'delete'">
                        <img :src="require('@/assets/icons/delete.svg')" />
                        <v-progress-circular v-if="deleteLoader" indeterminate :size="18"
                            :width="2"></v-progress-circular>
                    </button>
                    <button class="save-as-draft" @click="popupType = 'saveAsDraft'" :disabled="selectedDoc == null">
                        <img :src="require('@/assets/icons/save.svg')" />
                        <p>Save as Draft</p>
                    </button>
                </div>
                <div class="footer-left">

                    <button class="generate-btn" @click="handleGenerateClick()" :disabled="selectedDoc == null">
                        <p> Generate PR Strategy Playbook</p>
                        <img :src="require('@/assets/icons/next.svg')" alt="" />
                        <v-progress-circular v-if="nextStageLoader" indeterminate :size="18"
                            :width="2"></v-progress-circular>
                    </button>
                </div>
            </div>
        </div>
        <ConfirmPopup v-if="confirmPopup" v-model="confirmPopup" :title="popupData.title" :image="popupData.image"
            :type="popupData.type" />
        <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
            @confirm-action="handlePopupConfirmation" />
        <v-overlay v-if="showOverlayLoader" v-model="showOverlayLoader" class="overlay" persistent="true">
            <RotatingLoader :size="30" :speed="0.6" />
            <span>Generating</span>
        </v-overlay>

    </div>

</template>

<script>
import axiosInstance from '@/axiosInterceptor';
import CommonPopup from '@/components/CommonPopup.vue';
import { Eventbus } from '@/plugins/eventBus';
import SourceDocument from '@/components/SourceDocument.vue';
import RenamePopup from '@/components/RenamePopup.vue';
import RotatingLoader from '@/components/CircularProgressBar.vue';
import PrPlanCompleted from '@/views/PrPlan/PrPlanCompleted.vue';
import ConfirmPopup from '@/components/ConfirmPopup.vue';
import { downloadPr } from '@/helper/downloadPr';
export default {
    name: 'PrPlanDetails',
    components: {
        CommonPopup, SourceDocument, RenamePopup, RotatingLoader, PrPlanCompleted, ConfirmPopup
    },

    props: {

    },

    data() {
        return {
            downloadLoader: false,
            showOverlayLoader: false,
            showCommonPopup: false,
            pageLoader: false,
            currentStage: null,
            popupType: null,
            documentType: null,
            documentId: null,
            prCampaign: null,
            confirmPopup: false,
            selectedDoc: null,
            saveDraftLoader: false,
            prPlanTitle: '',
            isEditingTitle: false,
            sourceList: [],
            refresh: 0,
            deleteLoader: false,
            nextStageLoader: false,
            selectRules: [
                v => !!v || 'This field is required'
            ],
            isCompleted: false
        }
    },

    watch: {
        popupType() {
            if (this.popupType) {
                this.showCommonPopup = true;
            }
        },

        prCampaign: {
            handler(newVal) {
            },
            immediate: true,
            deep: true
        }

    },

    computed: {

    },

    methods: {
        async downloadFinalPr() {
            this.downloadLoader = true;
            const payload = {
                prCampaignId: this.$route.params.prCampaignId,
                flowType: "PR_CAMPAIGN"
            }
            await downloadPr(payload, this.prPlanTitle);
            this.downloadLoader = false;
        },
        async handlePopupConfirmation(val) {
            this.showCommonPopup = false;
            if (val === 'yes') {
                if (this.popupType === 'delete') {
                    axiosInstance.put('/prCampaign/delete', { prCampaignId: this.$route.params.prCampaignId })
                        .then((response) => {
                            if (response.status == 200) {
                                this.popupData = {
                                    title: 'PR Strategy Discarded',
                                    image: require('@/assets/icons/delete_red.svg'),
                                    type: 'success'
                                };
                                this.confirmPopup = true;
                                setTimeout(() => {
                                    this.confirmPopup = false;
                                    this.$router.push({ name: 'PrPlanHome' });
                                }, 2000);
                            }

                        })
                        .catch((error) => {
                            Eventbus.emit('commonSnackbar', {
                                snackType: 'error',
                                message: 'Error deleting narrative',
                            });
                        })
                }
                else if (this.popupType === 'saveAsDraft') {
                    const prCampaignId = this.$route.params.prCampaignId;
                    const payload = {
                        documentType: this.documentType,
                        documentId: this.documentId,
                        prCampaignId: prCampaignId

                    }
                    this.saveDraftLoader = true;
                    const response = await axiosInstance.put('/prCampaign/saveDraft', payload);
                    if (response.status == 200) {
                        this.popupData = {
                            title: 'PR Strategy saved as Draft',
                            image: require('@/assets/icons/success.svg'),
                            type: 'success'
                        };
                        this.confirmPopup = true;
                        setTimeout(() => {
                            this.confirmPopup = false;
                            this.$router.push({ name: 'PrPlanHome' });
                        }, 2000);

                    }
                    this.saveDraftLoader = false;
                }
                else {
                    this.$router.push({ name: 'PrPlanHome' });
                }
            }
            this.popupType = null;
        },
        async getPrPlanById(isFallback = false) {
            if(!isFallback) {
                this.pageLoader = true;
            }
            const prCampaignId = this.$route.params.prCampaignId;
            await axiosInstance.get(`/prCampaign/${prCampaignId}`)
                .then((response) => {
                    if (response.status === 200) {
                        this.documentId = response.data.data[0].documentId;
                        this.documentType = response.data.data[0].documentType
                        if (response.data.data[0].prCampaign) {
                            this.currentStage += 1;
                        }
                        else {
                            this.currentStage = 0;
                        }
                        this.prPlanTitle = response.data.data[0].title;
                        this.prCampaign = response.data.data[0].prCampaign;
                        this.prCampaign.title = response.data.data[0].title;
                    }
                })
                .catch((error) => {
                    Eventbus.emit({
                        snackType: 'error',
                        message: 'Failed to create new PR Strategy'
                    })
                })
                .finally(() => {
                    this.pageLoader = false;
                })
        },
        handleSelectedDoc(doc) {
            this.documentType = doc.sourceType;
            this.documentId = doc.documentId;
            this.selectedDoc = doc.selectedDocument;
        },
        async handleGenerateClick() {
            this.showOverlayLoader = true;
            try {
                const prCampaignId = this.$route.params.prCampaignId;
                const payload = {
                    documentType: this.documentType,
                    documentId: this.documentId,
                    prCampaignId: prCampaignId
                }
            

             const response = await axiosInstance.post('/prCampaign/generate', payload);
                if (response.status === 200) {
                    this.isCompleted = true;
                    this.getPrPlanById()
                    this.currentStage += 1;
                    this.refresh += 1;
                    this.showOverlayLoader = false
                }
            } catch (error) {
                console.error("Error generating PR Strategy", error);
                if (error.response?.status === 504 || error.code === 'ERR_NETWORK') {
                    let attempts = 0;
                    let maxAttempts = 2;
                    const intervalTime = 15000;
                    const intervalId = setInterval(async () => {
                        attempts++;
                        try {
                            let isFallback = true;
                            const plan = await this.getPrPlanById(isFallback);
                            if (this.prCampaign != null) {
                                clearInterval(intervalId);
                                this.currentStage += 1;
                                this.refresh += 1;
                                this.showOverlayLoader = false
                            } else if (attempts >= maxAttempts) {
                                clearInterval(intervalId);
                                Eventbus.emit('commonSnackbar', {
                                    snackType: 'warning',
                                    message: 'PR Strategy generation is taking longer than expected. Please check again later.',
                                });
                            }
                        } catch (pollError) {
                            console.error("Error during polling:", pollError);
                            this.showOverlayLoader = false
                            clearInterval(intervalId);
                            Eventbus.emit('commonSnackbar', {
                                snackType: 'error',
                                message: 'Failed to generate PR Strategy. Please try again later.',
                            });

                        }
                    }, intervalTime);
                }
            }
        },

        async getDocuments() {
            const response = await axiosInstance.get('/document')
            if (response.status === 200) {
                this.sourceList = response.data.data
            }
            else {
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Something went wrong, Please try again!',
                });
            }

        },

    },

    mounted() {
        this.getPrPlanById(),
            this.getDocuments()


    }
}
</script>

<style scoped>
.articles-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    background: var(--dark-background);
    background-size: 100% 100%;
}

.articles-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}

.no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

.articles-header {
    position: sticky;
    top: 0;
    right: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #FFFFFF14;
    color: white;
    z-index: 100;
    padding: 1rem 2rem;
}

.articles-header-wrapper {
    width: 54%;
    display: flex;
    justify-content: space-between;
    gap: 4.5rem;
    max-height: 44px;
}

.completed{
    width: 100%;
}

.completed-header {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 4.5rem;
    max-height: 44px;

}

.home-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF1F;
    border-radius: 8px;
    padding: 10px;
}

.header-title-wrapper {
    display: flex;
    justify-content: space-between;
}

.header-title {
    display: flex;
    align-items: center;
    gap: 16px;
    color: white;
    padding-left: 10rem;
}

.doc-title {
    font-weight: 500;
    text-align: center;
}

.edit-btn {
    display: flex;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    align-items: center;
    cursor: pointer;
}


.button-container{
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.share-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.completed-wrappershare {
    display: flex;
    align-items: center;
    gap: 0.5em;
}


.stage-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    align-items: center;
}

.completed-section {
    display: flex;
    height: 100%;
    overflow: hidden;
    flex-direction: column;
    align-items: center;
}

.articles-footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 2rem;
    background: #180914;
    border-top: 1px solid #FFFFFF33;
    color: white;
    z-index: 100;
}

.footer-left {
    display: flex;
    gap: 1em;
    align-items: center;
}

.delete-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 12px 8px 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    font-size: 14px;
}

.save-as-draft {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 24px 8px 24px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.save-as-draft p {
    font-size: 14px;
}

.generate-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 8px 20px;
    border-radius: 8px;
    background: var(--primary-gradient);
}
.download-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 8px 20px;
    border-radius: 8px;
    background: var(--primary-gradient-with-black);
}

.generate-btn :disabled {
    background: var(--primary-gradient-with-black);
}

.continue-btn {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
}

.overlay {
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 9999;
}

.overlay :deep(.v-overlay__content) {
    display: flex;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 1rem;
}
</style>